import React, { useContext, useState, useEffect } from 'react';
import QueueOutlinedIcon from '@mui/icons-material/QueueOutlined';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import CardBase from './CardBase';
import SubscriptionService from '../../services/SubscriptionService';
import RoomService from '../../services/RoomService';
import MessageContext from '../../App/Contexts/MessageContext';
import UserContext from '../../App/Contexts/UserContext';

function CreateRoomCard(props) {
    const [subscriptionLimit, setSubscriptionLimit] = useState(0);
    const { userId } = useContext(UserContext);

    useEffect(() => {
        SubscriptionService.getUserSubscriptionData(userId)
            .then((subscription) => {
                setSubscriptionLimit(subscription.numOfRooms);
            })
            .catch(console.error);
    });

    return (
        <CardBase dark tabText={`${subscriptionLimit - props.rooms.length} rooms left`} {...props}>
            <Grid container justifyContent='center'>
                <Typography color='textSecondary' gutterBottom>
                    Create
                </Typography>
            </Grid>
            <Grid container justifyContent='center'>
                <QueueOutlinedIcon />
            </Grid>
        </CardBase>
    );
}

export default CreateRoomCard;
